import React, { useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import frontendDeveloper from "../img/front-end-developer-course.avif";
import CourseContext from "../contexts/CourseContext";
import TextComponent from "./TextComponent";
import MyContext from "../contexts/Mycontexts";
import EnrolledContext from "../contexts/EnrolledContext";
import Swal from "sweetalert2";
import API_URL from "../ApuUrl";

export default function CoursePage() {
  const { allCourse, CourseById, getCourse } = useContext(CourseContext)
  const { EnrolRequests } = useContext(EnrolledContext)
  const [category, setCategory] = useState([])
  const { signUser } = useContext(MyContext)
  const [searchName, setSearchName] = useState("")
  const [searchCategory, setSearchCategory] = useState("")

  const Enrollment = async (id) => {
    const courseId = id
    const studentId = signUser?._id

    const res = await fetch(`${API_URL}/api/enrollCourse/enrollments`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ courseId, studentId }),
    });

    if (res.ok) {

      Swal.fire({
        position: "center",
        icon: "success",
        title: "Enrollment request send successfully",
        showConfirmButton: false,
        timer: 1500,
      });
      EnrolRequests()
    }
  };

  const getCategory = async () => {
    const res = await fetch(`${API_URL}/api/category/getcategory`, {
      method: 'GET'
    })
    const data = await res.json()
    setCategory(data)
  }
  useEffect(() => {
    getCategory()
  }, [])
  return (
    <div>
      {/* {/ {/ header start /} /} */}
      <section>
        <div className="head-bg">
          <div className="head-overlay">
            <h1 className="text-center text-white py-7">Courses</h1>
          </div>
        </div>
      </section>
      {/* {/ {/ header end /} /} */}

      <section className="courses-section py-4 bg-white">
        <div className="container">
          <div className="section-header text-center mb-4">
            <h2>Select Courses</h2>
            <h3>Explore Our Popular Courses</h3>
          </div>
          <div className="container mb-4">
            <div className="row find d-flex justify-content-between">
              <div className="col-md-4 mt-4">
                <input
                  type="text"
                  className="form-control schoo-search"
                  placeholder="Search By Title"
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                />
              </div>

              <div className="col-md-4 mt-4">
                <select className="form-control" name="" id="" value={searchCategory} onChange={(e) => setSearchCategory(e.target.value)} style={{ backgroundColor: "white" }}>
                  <option value="">Search By Category</option>
                  {category && category.map((cat) => {
                    return <option value={cat._id}>{cat.category}</option>
                  })}
                </select>
              </div>
            </div>
          </div>

          <div className="row g-4">
            {allCourse && allCourse.filter(course => course.title.toLowerCase().includes(searchName.toLowerCase()))
              .filter(course => course.categoryId.includes(searchCategory))
              .reverse()
              .map((data, index) => {
                return <div className="col-md-4" key={index}>
                  <div className="card courses" style={{ height: '100%' }}>
                    <div className="course-content">
                      <img src={data.image ? data.image : frontendDeveloper} alt={`course-img${index}`} className="img-fluid" style={{ height: "200px", width: "100%" }} />
                    </div>
                    <div className="course-title p-4">
                      <p className="bold-p">{data.title.length > 20 ? data.title.slice(0, 20) + "..." : data.title}</p>
                      <hr />
                      {data.instructorName ? (
                        <p>
                          Instructor Name: <span className="replaceStrong">{data.instructorName}</span>
                        </p>
                      ) : (
                        <p>
                          Instructor Name: <span className="replaceStrong">{data.name}</span>
                        </p>
                      )}
                      <p>
                        Duration: <span className="replaceStrong">{data.duration}</span>
                      </p>
                    </div>
                    <div className="join mb-2">
                      <Link to={`/course-details/${data.title.replace(/ /g, '-')}`}>
                        <button className="first-button">View Contents</button>
                      </Link>
                      {signUser && signUser.name ? (
                        <button className="second-button float-end" onClick={() => Enrollment(data._id)}>
                          Enroll Now
                        </button>
                      ) : (
                        <Link to="/signin">
                          <button className="second-button float-end">
                            Enroll Now
                          </button>
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              })}
          </div>
          <TextComponent />
        </div>
      </section>
    </div>
  )
}